module.exports = __webpack_public_path__ + "img/cb44801a789d30400e370b57919012a2.svg";